import * as CONST from '../ActionTypes';

const initialState = {
  ruleGroupList: [],
  ruleGroup: {},
  query: {
    currentPage: 0,
    itemsPerPage: 10,
    sort: 'created_at',
    isAsc: false,
    ruleGroupName: '',
  },
};

function ruleGroup(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // ルールグループ一覧取得
    // -----------------
    case CONST.GET_RULE_GROUP_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          ruleGroupList: action.payload,
        },
      );
    case CONST.GET_RULE_GROUP_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          ruleGroupList: [],
        },
      );
    // -----------------
    // ルールグループ詳細取得
    // -----------------
    case CONST.GET_RULE_GROUP_DETAIL_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          ruleGroup: action.payload,
        },
      );
    case CONST.GET_RULE_GROUP_DETAIL_FAILURE:
      return Object.assign(
        {},
        state,
        {
          ruleGroup: {},
        },
      );
    // -----------------
    // queryパラメータの設定
    // -----------------
    case CONST.SET_RULE_GROUP_QUERY:
      return Object.assign(
        {},
        state,
        {
          query: Object.assign(
            {},
            state,
            action.payload,
          ),
        },
      );
    default:
      return state;
  }
}

export default ruleGroup;
